import React from 'react';
import Header from './Header';
import CategoryNav from './CategoryNav';
import HeroBanner from './HeroBanner';
import ProductGrid from './ProductGrid';
import StatsSection from './StatsSection';
import ReadyToShipStyles from './ReadyToShipStyles';
import FeaturesSection from './FeaturesSection';
import CallToAction from './CallToAction';
import FooterSection from './Footersection';
import TrendingProductGrid from './TrendingProductGrid';
import { Cat } from 'lucide-react';
import CategoriesSection from './CategoriesSection';
import TestimonialsSection from './TestimonialsSection';

function Home() {
  return (
    <div className="flex overflow-hidden flex-col pb-0 bg-stone-200">
      <Header />
      {/* <CategoryNav /> */}
      <HeroBanner />
      <CategoriesSection/>
      <ProductGrid />
      <StatsSection />
      <ReadyToShipStyles />
      <TrendingProductGrid/>
      <FeaturesSection />
      <CallToAction />
      <TestimonialsSection/>
      <FooterSection />
    </div>
  );
}

export default Home;
